<template>
    <div class="folder-form">
        
        <div class="block">
            <button class="button is-success"                                 
                id="createFolder" v-on:click="createFolderClick">Create new folder</button>
        </div>

        <div>
            <div class="block" v-for="folder in folders" v-bind:value="folder.rowKey" v-bind:key="folder.rowKey">
                <div class="button folder" @click="selectFolder(folder)">{{ folder.name }}</div>
            </div>
        </div>
       
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
    name: "Folders",
    async created () {
        if(!this.$store.state.accessToken){
            this.$router.push('login');
            return;            
        }
        else{
            this.showLoginMessage = true;
        }
        await this.loadFolders();
    },
    data() {
        return {
            selected: "",            
        }
    },
    methods: {     
        ...mapActions(['getFoldersAction', 'selectFolderAction']),  
        async createFolderClick(){
            this.$router.push('folder');
        },
        async loadFolders() {
            await this.getFoldersAction();
        }, 
        async selectFolder(folder){
            await this.selectFolderAction(folder);
            this.$router.push('tester');
        }
        
    },
    computed: {
        ...mapState(['folders']),        
    },    
}
</script>